"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.setMessage = exports.drawAll = exports.reset = exports.getLastMessage = exports.addExp = exports.addGold = exports.getStats = void 0;
var rogueInput_1 = require("../input/rogueInput");
var rogueInput_sidecar_1 = require("../input/rogueInput-sidecar");
var rogueMaps_sidecar_1 = require("../map/rogueMaps-sidecar");
var rogueMonofont_sidecar_1 = require("../monofont/rogueMonofont-sidecar");
var rogueMonsters_sidecar_1 = require("../monsters/rogueMonsters-sidecar");
var rogueDef_sidecar_1 = require("../rogueDef-sidecar");
var rogueUiCast_sidecar_1 = require("./rogueUiCast-sidecar");
var rogueUiHelp_sidecar_1 = require("./rogueUiHelp-sidecar");
var rogueUiInventory_sidecar_1 = require("./rogueUiInventory-sidecar");
var rogueUiMessages_sidecar_1 = require("./rogueUiMessages-sidecar");
var rogueUiStory_sidecar_1 = require("./rogueUiStory-sidecar");
var _stats = {
    gold: 1234,
    level: 1,
    exp: 0,
    messages: [],
};
var getStats = function () {
    return _stats;
};
exports.getStats = getStats;
var addGold = function (amount) {
    _stats.gold += amount;
};
exports.addGold = addGold;
var addExp = function (amount) {
    _stats.exp += amount;
    if (_stats.exp >= 5) {
        _stats.exp -= 5;
        _stats.level++;
        (0, exports.setMessage)('You reached level ' + _stats.level + '!');
    }
};
exports.addExp = addExp;
var getLastMessage = function () {
    return _stats.messages[_stats.messages.length - 1] || 'no messages';
};
exports.getLastMessage = getLastMessage;
var reset = function () {
    _stats.gold = 0;
    _stats.exp = 0;
    _stats.level = 1;
    _stats.messages = [];
};
exports.reset = reset;
var drawAll = function () {
    // rogueMonofont.write(0, 0, 'Hello Rogue!')
    var _a;
    var x = 1;
    var y = 20;
    rogueMonofont_sidecar_1.rogueMonofont.write(x, y, '$' + _stats.gold);
    x += 5;
    rogueMonofont_sidecar_1.rogueMonofont.write(x, y, 'Depth:' + ((_a = rogueMaps_sidecar_1.rogueMaps.getCurrentMap()) === null || _a === void 0 ? void 0 : _a.dungeonLevel));
    var p = rogueMonsters_sidecar_1.rogueMonsters.getPlayer();
    if (p) {
        x += 8;
        rogueMonofont_sidecar_1.rogueMonofont.write(x, y, 'Level:' + _stats.level + ' Exp:' + _stats.exp);
        x += 16;
        rogueMonofont_sidecar_1.rogueMonofont.write(x, y, 'Hp:' + p.hp + '/' + p.maxHp);
    }
    y++;
    x = 1;
    rogueMonofont_sidecar_1.rogueMonofont.write(x, y, (0, exports.getLastMessage)());
    y = 0;
    x = 1;
    x +=
        rogueMonofont_sidecar_1.rogueMonofont.write(x, y, 'Inv', rogueDef_sidecar_1.rogueDef.colors.light, rogueDef_sidecar_1.rogueDef.colors.dark, function () {
            if (rogueUiInventory_sidecar_1.rogueUiInventory.isOpen()) {
                rogueInput_sidecar_1.rogueInput.setNextInputCommand(rogueInput_1.EInputCommand.cancel);
            }
            else {
                rogueInput_sidecar_1.rogueInput.setNextInputCommand(rogueInput_1.EInputCommand.openInventory);
            }
        }) + 1;
    x +=
        rogueMonofont_sidecar_1.rogueMonofont.write(x, y, 'Zap', rogueDef_sidecar_1.rogueDef.colors.light, rogueDef_sidecar_1.rogueDef.colors.dark, function () {
            if (rogueUiCast_sidecar_1.rogueUiCast.isOpen()) {
                rogueInput_sidecar_1.rogueInput.setNextInputCommand(rogueInput_1.EInputCommand.cancel);
            }
            else {
                rogueInput_sidecar_1.rogueInput.setNextInputCommand(rogueInput_1.EInputCommand.openCastMenu);
            }
        }) + 1;
    x +=
        rogueMonofont_sidecar_1.rogueMonofont.write(x, y, 'Msgs', rogueDef_sidecar_1.rogueDef.colors.light, rogueDef_sidecar_1.rogueDef.colors.dark, function () {
            if (rogueUiMessages_sidecar_1.rogueUiMessages.get().isOpen) {
                rogueInput_sidecar_1.rogueInput.setNextInputCommand(rogueInput_1.EInputCommand.cancel);
            }
            else {
                rogueInput_sidecar_1.rogueInput.setNextInputCommand(rogueInput_1.EInputCommand.openMessages);
            }
        }) + 1;
    x +=
        rogueMonofont_sidecar_1.rogueMonofont.write(x, y, 'Help', rogueDef_sidecar_1.rogueDef.colors.light, rogueDef_sidecar_1.rogueDef.colors.dark, function () {
            if (rogueUiHelp_sidecar_1.rogueUiHelp.get().isOpen) {
                rogueInput_sidecar_1.rogueInput.setNextInputCommand(rogueInput_1.EInputCommand.cancel);
            }
            else {
                rogueInput_sidecar_1.rogueInput.setNextInputCommand(rogueInput_1.EInputCommand.openHelp);
            }
        }) + 1;
    x +=
        rogueMonofont_sidecar_1.rogueMonofont.write(x, y, 'Story', rogueDef_sidecar_1.rogueDef.colors.light, rogueDef_sidecar_1.rogueDef.colors.dark, function () {
            if (rogueUiStory_sidecar_1.rogueUiStory.get().isOpen) {
                rogueInput_sidecar_1.rogueInput.setNextInputCommand(rogueInput_1.EInputCommand.cancel);
            }
            else {
                rogueInput_sidecar_1.rogueInput.setNextInputCommand(rogueInput_1.EInputCommand.openStory);
            }
        }) + 1;
    x = 0;
    y = -1;
    rogueMonofont_sidecar_1.rogueMonofont.write(x, y, 'Untitled Roguelike', rogueDef_sidecar_1.rogueDef.colors.light);
};
exports.drawAll = drawAll;
var setMessage = function (message) {
    _stats.messages.push(message);
    if (_stats.messages.length > 10) {
        _stats.messages.shift();
    }
    // _stats.lastMessage = message
};
exports.setMessage = setMessage;
